import { useQueryClient } from 'react-query'

import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { useMutationApi } from 'utils/api'
import { apiPaths, queryKeys } from 'api/kinerja/pengawas-sekolah/config'

import type { AxiosError } from 'axios'

export function useAPISubmitTugasPokok() {
  const { period } = usePeriodContext()
  const queryClient = useQueryClient()
  const apiPath = apiPaths.tugasPokok(period.id)

  return useMutationApi<unknown, AxiosError, void>(apiPath, {
    axiosConfig: { method: 'POST' },
    mutationConfig: {
      onSettled() {
        queryClient.invalidateQueries([
          queryKeys.API_GET_PERENCANAAN,
          period.id,
        ])
      },
    },
  })
}
